import { useContext, useEffect, useRef, useState } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import { DARK_THEME } from "../../constants/themeConstants";
import xpope from "../../assets/images/xpope.png";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import {
  MdAvTimer,
  MdCheckBox,
  MdChecklistRtl,
  MdDataUsage,
  MdDetails,
  MdErrorOutline,
  MdLocalActivity,
  MdOutlineManageAccounts,
  MdOutlineReceiptLong,
  MdScreenLockPortrait,
  MdSummarize,
} from "react-icons/md";
import { FaListCheck } from "react-icons/fa6";
import { TbLockAccessOff, TbRegistered, TbReport } from "react-icons/tb";
import {
  MdOutlineClose,
  MdOutlineCurrencyExchange,
  MdOutlineGridView,
  MdHandshake,
  MdBackHand,
} from "react-icons/md";
import { TbCloudDataConnection } from "react-icons/tb";
import { MdAssignmentAdd } from "react-icons/md";
import { MdOutlineViewKanban } from "react-icons/md";
import { FaSellcast, FaUsers, FaWpforms } from "react-icons/fa";
import "./Sidebar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Sidebar.scss";
import { SidebarContext } from "../../context/SidebarContext";
import { BiMessageAltCheck, BiSupport } from "react-icons/bi";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { useSelector } from "react-redux";
import { CurrencyBitcoin } from "@mui/icons-material";
import { IoWallet } from "react-icons/io5";
import axios from "axios";

const Sidebar = ({ allActivities }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme } = useContext(ThemeContext);
  const { isSidebarOpen, closeSidebar } = useContext(SidebarContext);
  const [sideNavData, setSideNavData] = useState("/dashboard");
  const [showUser, setShowUser] = useState(false);
  const [showMerchant, setShowMerchant] = useState(false);
  const [showTransaction, setShowTransaction] = useState(false);
  const [showRollingReserve, setShowRollingReserve] = useState(false);
  const [showReconciliation, setShowReconciliation] = useState(false);
  const [showComplaints, setShowComplaints] = useState(false);
  const [showProvider, setShowProvider] = useState(false);
  const [showSettlement, setShowSettlement] = useState(false);
  const [showWallet, setShowWallet] = useState(false);
  const [providerWallet, setProvoderWallet] = useState(false);
  const [support, setSupport] = useState(false);
  const [showOrg, setShoworg] = useState(false);
  const [showRecon, setShowRecon] = useState(false);

  const [showAutoSwitch, setShowAutoSwitch] = useState(false);
  const [reseller, setReseller] = useState(false);

  const navbarRef = useRef(null);
  const role = useSelector((store) => store.userReducer.role);
  const token = useSelector((store) => store.userReducer.token);
  const userId = useSelector((store) => store.userReducer.userId);
  const payoutFormAccess = useSelector(
    (store) => store.userReducer.payoutFormAccess,
  );

  const handleClickOutside = (event) => {
    if (
      navbarRef.current &&
      !navbarRef.current.contains(event.target) &&
      event.target.className !== "sidebar-oepn-btn"
    ) {
      closeSidebar();
    }
  };

  useEffect(() => {
    setSideNavData(location.pathname);
  }, [location]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleRouteByRole = () => {
    if (role === "mops") navigate("/pay-in");
    else if (role === "pros") navigate("/transaction-lookup");
    else if (role === "accounts") navigate("/view-settlement");
    else if (role === "operation") navigate("/usermanagement");
    else if (role === "fundLoad") navigate("/merchant-settlement");
    else if (role === "compliance") navigate("/chargeback-dashboard");
    else if (role === "trafficManager") navigate("/user-provider-set");
    else if (role === "reseller") navigate("/get-reseller");
    else navigate("/dashboard");
  };

  const isReseller = role === "reseller";
  const hasResellerAccess = [
    "super",
    "subSuper",
    "operation",
    "reseller",
  ].includes(role);
  const canAddResellerWallet = ["super", "subSuper", "operation"].includes(
    role,
  );

  const isActive = (path) =>
    sideNavData === path
      ? "menu-link selected-tab select-data"
      : "menu-link select-data";

  const MenuItem = ({ to, icon: Icon, label }) => (
    <li className="menu-item mar-l">
      <Link to={to} className={isActive(to)}>
        <span className="menu-link-icon">
          <Icon size={18} />
        </span>
        <span className="menu-link-text">{label}</span>
      </Link>
    </li>
  );
  const openSupportPortal = async () => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_BACKEND_API_URL}/v1/admin/auth/helpdesk-sso`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "x-skip": "true",
          },
        },
      );

      console.log("SSO Response:", response.data);

      window.open(response.data.url, "_blank");
    } catch (error) {
      console.log("SSO Error:", error);
      toast.error("Unable to open helpdesk");
    }
  };

  return (
    <nav
      className={`sidebar ${isSidebarOpen ? "sidebar-show" : ""}`}
      ref={navbarRef}
    >
      <div
        className="sidebar-top"
        style={{ cursor: "pointer" }}
        onClick={handleRouteByRole}
      >
        <div className="sidebar-brand">
          <div className="nav-main-pope">
            <img
              src={theme === DARK_THEME ? xpope : xpope}
              alt=""
              className="img-main-show"
            />
          </div>
          <img src={xpope} alt="" className="xpope-title" />
        </div>
        <button className="sidebar-close-btn" onClick={closeSidebar}>
          <MdOutlineClose size={24} />
        </button>
      </div>
      <div className="sidebar-body">
        <div className="sidebar-menu">
          <ul className="menu-list">
            {(payoutFormAccess === true) &
            (userId !== "fccdc4bb-32f3-4289-9663-61b77ecc49c5") ? (
              <>
                <li className="menu-item">
                  <Link
                    to="/dashboard"
                    className={
                      sideNavData == "/dashboard"
                        ? "menu-link selected-tab select-data"
                        : "menu-link select-data"
                    }
                  >
                    <span className="menu-link-icon">
                      <MdOutlineGridView size={18} />
                    </span>
                    <span className="menu-link-text">Dashboard</span>
                  </Link>
                </li>
                <li className="menu-item">
                  <Link
                    to="/pay-out-form"
                    className={
                      sideNavData == "/pay-out-form"
                        ? "menu-link selected-tab select-data"
                        : "menu-link select-data"
                    }
                  >
                    <span className="menu-link-icon">
                      <FaWpforms size={18} />
                    </span>
                    <span className="menu-link-text">Pay Out Form</span>
                  </Link>
                </li>
                <li className="menu-item">
                  <Link
                    to="/pay-out-report"
                    className={
                      sideNavData == "/pay-out-report"
                        ? "menu-link selected-tab select-data"
                        : "menu-link select-data"
                    }
                  >
                    <span className="menu-link-icon">
                      <TbReport size={18} />
                    </span>
                    <span className="menu-link-text">Pay Out Report</span>
                  </Link>
                </li>
                <li className="menu-item">
                  <Link
                    to="/transaction-lookup"
                    className={
                      sideNavData == "/transaction-lookup"
                        ? "menu-link selected-tab select-data"
                        : "menu-link select-data"
                    }
                  >
                    <span className="menu-link-icon">
                      <BiMessageAltCheck size={20} />
                    </span>
                    <span className="menu-link-text">Lookup</span>
                  </Link>
                </li>
                <li className="menu-item">
                  <Link
                    to="/download-report"
                    className={
                      sideNavData == "/download-report"
                        ? "menu-link selected-tab select-data"
                        : "menu-link select-data"
                    }
                  >
                    <span className="menu-link-icon">
                      <MdOutlineManageAccounts size={20} />
                    </span>
                    <span className="menu-link-text">Download Report</span>
                  </Link>
                </li>
              </>
            ) : (
              <>
                {role != "mops" &&
                  role != "accounts" &&
                  role != "fundLoad" &&
                  role !== "compliance" &&
                  role != "pros" &&
                  role != "trafficManager" &&
                  role != "reseller" &&
                  role != "operation" && (
                    <li className="menu-item">
                      <Link
                        to="/dashboard"
                        className={
                          sideNavData == "/dashboard"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <MdOutlineGridView size={18} />
                        </span>
                        <span className="menu-link-text">Dashboard</span>
                      </Link>
                    </li>
                  )}

                {(role === "super" ||
                  role === "operation" ||
                  role === "subSuper" ||
                  role == "accounts") && (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setShoworg(!showOrg);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <TbCloudDataConnection size={20} />
                        </span>
                        <span className="menu-link-text">Organization</span>
                      </div>

                      {showOrg ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </div>
                  </li>
                )}

                {showOrg && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/overview"
                      className={
                        sideNavData == "/overview"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdOutlineGridView size={18} />
                      </span>
                      <span className="menu-link-text">Overview</span>
                    </Link>
                  </li>
                )}
                {showOrg &&
                  (role === "super" ||
                    role === "operation" ||
                    role === "subSuper") && (
                    <li className="menu-item mar-l">
                      <Link
                        to="/add-organization"
                        className={
                          sideNavData == "/add-organization"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <MdAssignmentAdd size={18} />
                        </span>
                        <span className="menu-link-text">Add Organization</span>
                      </Link>
                    </li>
                  )}

                {showOrg &&
                  (role === "super" ||
                    role === "operation" ||
                    role === "subSuper") && (
                    <li className="menu-item mar-l">
                      <Link
                        to="/orgTable"
                        className={
                          sideNavData == "/orgTable"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <MdOutlineViewKanban size={18} />
                        </span>
                        <span className="menu-link-text">
                          View Orgranization
                        </span>
                      </Link>
                    </li>
                  )}

                {role !== "mops" &&
                role !== "pros" &&
                role != "reseller" &&
                role !== "fundLoad" &&
                role !== "compliance" ? (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setShowTransaction(false);
                      setShowUser(!showUser);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <FaUsers size={20} />
                        </span>
                        <span className="menu-link-text">Users</span>
                      </div>

                      {showUser ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </div>
                  </li>
                ) : null}

                {role !== "mops" &&
                role !== "pros" &&
                role !== "trafficManager" &&
                role != "reseller" &&
                role !== "accounts" &&
                showUser ? (
                  <li
                    className={`menu-item ${
                      role !== "mops" || role !== "pros" || role !== "accounts"
                        ? "mar-l"
                        : ""
                    }`}
                  >
                    <Link
                      to="/usermanagement"
                      className={
                        sideNavData == "/usermanagement"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <FaUsers size={20} />
                      </span>
                      <span className="menu-link-text">User Management</span>
                    </Link>
                  </li>
                ) : null}

                {showUser &&
                (role === "super" ||
                  role === "operation" ||
                  role === "subSuper" ||
                  role === "accounts") ? (
                  <li className="menu-item mar-l">
                    <Link
                      to="/merchant-management"
                      className={
                        sideNavData == "/merchant-management"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <FaUsers size={20} />
                      </span>
                      <span className="menu-link-text">
                        Merchant Management
                      </span>
                    </Link>
                  </li>
                ) : null}

                {showUser &&
                (role === "super" ||
                  role === "operation" ||
                  role === "trafficManager") ? (
                  <li className="menu-item mar-l">
                    <Link
                      to="/user-provider-set"
                      className={
                        sideNavData == "/user-provider-set"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <BiMessageAltCheck size={20} />
                      </span>
                      <span className="menu-link-text">Active Provider</span>
                    </Link>
                  </li>
                ) : null}

                {role === "super" ||
                role === "operation" ||
                role === "subSuper" ? (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setShowTransaction(false);
                      setShowMerchant(!showMerchant);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <FaUsers size={20} />
                        </span>
                        <span className="menu-link-text">Merchants</span>
                      </div>

                      {showMerchant ? (
                        <IoMdArrowDropup />
                      ) : (
                        <IoMdArrowDropdown />
                      )}
                    </div>
                  </li>
                ) : null}

                {(role === "super" ||
                  role === "operation" ||
                  role === "subSuper") &&
                showMerchant ? (
                  <li
                    className={`menu-item ${
                      role === "super" ||
                      role === "operation" ||
                      role === "trafficManager"
                        ? "mar-l"
                        : ""
                    }`}
                  >
                    <Link
                      to="/merchant-overview"
                      className={
                        sideNavData == "/merchant-overview"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <FaUsers size={20} />
                      </span>
                      <span className="menu-link-text">Overview</span>
                    </Link>
                  </li>
                ) : null}
                <>
                  {role !== "fundLoad" && role != "reseller" && (
                    <li
                      className="menu-item"
                      onClick={() => {
                        setShowUser(false);
                        setShowTransaction(!showTransaction);
                      }}
                    >
                      <div className={"select-data drop-menu"}>
                        <div className="inner-drop">
                          <span className="menu-link-icon">
                            <MdOutlineCurrencyExchange size={20} />
                          </span>
                          <span className="menu-link-text">Transactions</span>
                        </div>

                        {showTransaction ? (
                          <IoMdArrowDropup />
                        ) : (
                          <IoMdArrowDropdown />
                        )}
                      </div>
                    </li>
                  )}
                  {showTransaction && (
                    <>
                      {role !== "pros" &&
                        role != "reseller" &&
                        role !== "compliance" && (
                          <li className="menu-item mar-l">
                            <Link
                              to="/pay-in"
                              className={
                                sideNavData == "/pay-in"
                                  ? "menu-link selected-tab select-data"
                                  : "menu-link select-data"
                              }
                            >
                              <span className="menu-link-icon">
                                <MdOutlineCurrencyExchange size={18} />
                              </span>
                              <span className="menu-link-text">
                                Payin Report
                              </span>
                            </Link>
                          </li>
                        )}

                      {role !== "pros" &&
                        role != "reseller" &&
                        role !== "compliance" && (
                          <li className="menu-item mar-l">
                            <Link
                              to="/pay-out-report"
                              className={
                                sideNavData == "/pay-out-report"
                                  ? "menu-link selected-tab select-data"
                                  : "menu-link select-data"
                              }
                            >
                              <span className="menu-link-icon">
                                <TbReport size={18} />
                              </span>
                              <span className="menu-link-text">
                                Pay Out Report
                              </span>
                            </Link>
                          </li>
                        )}

                      {role !== "mops" &&
                        role !== "compliance" &&
                        role !== "subAdmin" &&
                        role != "reseller" &&
                        role !== "trafficManager" &&
                        role !== "pros" &&
                        role !== "accounts" && (
                          <li className="menu-item mar-l">
                            <Link
                              to="/pay-out-form"
                              className={
                                sideNavData == "/pay-out-form"
                                  ? "menu-link selected-tab select-data"
                                  : "menu-link select-data"
                              }
                            >
                              <span className="menu-link-icon">
                                <FaWpforms size={18} />
                              </span>
                              <span className="menu-link-text">
                                Pay Out Form
                              </span>
                            </Link>
                          </li>
                        )}
                    </>
                  )}

                  {showTransaction && role != "reseller" ? (
                    <li className="menu-item mar-l">
                      <Link
                        to="/transaction-lookup"
                        className={
                          sideNavData == "/transaction-lookup"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <BiMessageAltCheck size={20} />
                        </span>
                        <span className="menu-link-text">Lookup</span>
                      </Link>
                    </li>
                  ) : null}

                  {role !== "pros" &&
                  role !== "compliance" &&
                  role != "reseller" &&
                  role !== "trafficManager" &&
                  (role === "mops" || showTransaction) ? (
                    <li
                      className={`menu-item ${role !== "mops" ? "mar-l" : ""}`}
                    >
                      <Link
                        to="/download-report"
                        className={
                          sideNavData == "/download-report"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <MdOutlineManageAccounts size={20} />
                        </span>
                        <span className="menu-link-text">Download Report</span>
                      </Link>
                    </li>
                  ) : null}
                </>

                {role !== "mops" &&
                  role !== "pros" &&
                  role !== "fundLoad" &&
                  role != "reseller" &&
                  role !== "trafficManager" &&
                  role !== "compliance" && (
                    <li
                      className="menu-item "
                      onClick={() => {
                        setShowUser(false);
                        setShowTransaction(false);
                        setShowRollingReserve(!showRollingReserve);
                      }}
                    >
                      <div className={"select-data drop-menu"}>
                        <div className="inner-drop">
                          <span className="menu-link-icon">
                            <FaUsers size={20} />
                          </span>
                          <span className="menu-link-text">
                            Rolling Reserve
                          </span>
                        </div>

                        {showRollingReserve ? (
                          <IoMdArrowDropup />
                        ) : (
                          <IoMdArrowDropdown />
                        )}
                      </div>
                    </li>
                  )}
                {showRollingReserve && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/rolling-reserve"
                      className={
                        sideNavData == "/rolling-reserve"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdOutlineManageAccounts size={20} />
                      </span>
                      <span className="menu-link-text">Transaction</span>
                    </Link>
                  </li>
                )}

                {showRollingReserve && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/rolling-reserve-settlements"
                      className={
                        sideNavData == "/rolling-reserve-settlements"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdOutlineManageAccounts size={20} />
                      </span>
                      <span className="menu-link-text">Settlements</span>
                    </Link>
                  </li>
                )}

                {role !== "mops" &&
                role !== "pros" &&
                role !== "accounts" &&
                role !== "subAdmin" &&
                role !== "compliance" &&
                role !== "trafficManager" &&
                role != "reseller" &&
                role !== "fundLoad" ? (
                  <li className="menu-item">
                    <Link
                      to="/account"
                      className={
                        sideNavData == "/account"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdOutlineManageAccounts size={20} />
                      </span>
                      <span className="menu-link-text">
                        Account
                         {allActivities.length > 0 &&
                          (role === "super") && (
                            <span className="notification-badge-sidebar">
                              {allActivities.length >= 11
                                ? "10+"
                                : allActivities.length}
                            </span>
                          )}
                      </span>
                    </Link>
                  </li>
                ) : null}

                {/* {(role === "super" || role === "operation" || role === "admin" || role === "subSuper") && (
              <li className="menu-item">
                <Link
                  to="/passbook"
                  className={
                    sideNavData == "/passbook"
                      ? "menu-link selected-tab select-data"
                      : "menu-link select-data"
                  }
                >
                  <span className="menu-link-icon">
                    <MdOutlineAccountBalanceWallet size={20} />
                  </span>
                  <span className="menu-link-text">Account Summary</span>
                </Link>
              </li>
            )} */}
                {(role === "super" ||
                  role === "operation" ||
                  role === "subSuper" ||
                  role === "trafficManager") && (
                  <li className="menu-item">
                    <Link
                      to="/monthly-analytics"
                      className={
                        sideNavData == "/monthly-analytics"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdOutlineReceiptLong size={18} />
                      </span>
                      <span className="menu-link-text">Merchant Ledger</span>
                    </Link>
                  </li>
                )}
                {role === "super" ||
                role === "operation" ||
                role === "subSuper" ? (
                  <li className="menu-item">
                    <Link
                      to="/activity"
                      className={
                        sideNavData.includes("/activity")
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdLocalActivity size={20} />
                      </span>
                      <span className="menu-link-text">Activity</span>
                    </Link>
                  </li>
                ) : null}
                {/* {role !== "mops" ? (
              <li className="menu-item">
                <Link
                  to="/apipage"
                  className={
                    sideNavData == "/apipage"
                      ? "menu-link selected-tab select-data"
                      : "menu-link select-data"
                  }
                >
                  <span className="menu-link-icon">
                    <BiMessageAltCheck size={20} />
                  </span>
                  <span className="menu-link-text">Api Integration</span>
                </Link>
              </li>
            ) : null} */}

                {(role === "super" ||
                  role === "operation" ||
                  role === "subSuper" ||
                  role === "trafficManager") && (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setShowProvider(!showProvider);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <TbCloudDataConnection size={20} />
                        </span>
                        <span className="menu-link-text">Provider</span>
                      </div>

                      {showProvider ? (
                        <IoMdArrowDropup />
                      ) : (
                        <IoMdArrowDropdown />
                      )}
                    </div>
                  </li>
                )}

                {showProvider && role !== "trafficManager" && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/add-provider"
                      className={
                        sideNavData == "/add-provider"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdAssignmentAdd size={18} />
                      </span>
                      <span className="menu-link-text">Add Provider</span>
                    </Link>
                  </li>
                )}

                {showProvider && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/get-provider"
                      className={
                        sideNavData == "/get-provider"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdOutlineViewKanban size={18} />
                      </span>
                      <span className="menu-link-text">View Provider</span>
                    </Link>
                  </li>
                )}

                {showProvider && role !== "trafficManager" && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/check-provider"
                      className={
                        sideNavData == "/check-provider"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdChecklistRtl size={18} />
                      </span>
                      <span className="menu-link-text">Check Provider</span>
                    </Link>
                  </li>
                )}

                {showProvider && role !== "trafficManager" && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/vpa-usage"
                      className={
                        sideNavData == "/vpa-usage"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdDataUsage size={18} />
                      </span>
                      <span className="menu-link-text">VPA Usage</span>
                    </Link>
                  </li>
                )}
                {showProvider && role !== "trafficManager" && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/provider-tracking"
                      className={
                        sideNavData == "/provider-tracking"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdSummarize size={18} />
                      </span>
                      <span className="menu-link-text">Provider Tracking</span>
                    </Link>
                  </li>
                )}

                {/* <li className="menu-item">
                <Link
                  to="/auto-payout-report"
                  className={
                    sideNavData == "/auto-payout-report"
                      ? "menu-link selected-tab select-data"
                      : "menu-link select-data"
                  }
                >
                  <span className="menu-link-icon">
                    <BiMessageAltCheck size={20} />
                  </span>
                  <span className="menu-link-text">Auto Payout</span>
                </Link>
              </li> */}

                {(role === "super" ||
                  role === "operation" ||
                  role === "subSuper") && (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setShowRecon(!showRecon);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <TbCloudDataConnection size={20} />
                        </span>
                        <span className="menu-link-text">Reconciliation</span>
                      </div>

                      {showRecon ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </div>
                  </li>
                )}

                {showRecon && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/transaction-summary"
                      className={
                        sideNavData == "/transaction-summary"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdOutlineGridView size={18} />
                      </span>
                      <span className="menu-link-text">
                        Transaction Summary
                      </span>
                    </Link>
                  </li>
                )}

                {showRecon &&
                  (role === "super" ||
                    role === "operation" ||
                    role === "subSuper") && (
                    <li className="menu-item mar-l">
                      <Link
                        to="/pending-payouts"
                        className={
                          sideNavData == "/pending-payouts"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <MdAssignmentAdd size={18} />
                        </span>
                        <span className="menu-link-text">Pending Payouts</span>
                      </Link>
                    </li>
                  )}

                {showRecon &&
                  (role === "super" ||
                    role === "operation" ||
                    role === "subSuper") && (
                    <li className="menu-item mar-l">
                      <Link
                        to="/muffin-clear"
                        className={
                          sideNavData == "/muffin-clear"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <MdOutlineViewKanban size={18} />
                        </span>
                        <span className="menu-link-text">Muffin Clear</span>
                      </Link>
                    </li>
                  )}

                {showRecon && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/muffin-amount"
                      className={
                        sideNavData == "/muffin-amount"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdOutlineGridView size={18} />
                      </span>
                      <span className="menu-link-text">Muffin Amount</span>
                    </Link>
                  </li>
                )}

                {role === "super" ||
                role === "operation" ||
                role === "subSuper" ? (
                  <li className="menu-item">
                    <Link
                      to="/direct-payout"
                      className={
                        sideNavData == "/direct-payout"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <BiMessageAltCheck size={20} />
                      </span>
                      <span className="menu-link-text">Direct Payout</span>
                    </Link>
                  </li>
                ) : null}

                <>
                  {role != "pros" &&
                    role != "reseller" &&
                    role != "trafficManager" && (
                      <li
                        className="menu-item"
                        onClick={() => {
                          setShowReconciliation(!showReconciliation);
                        }}
                      >
                        <div className={"select-data drop-menu"}>
                          <div className="inner-drop">
                            <span className="menu-link-icon">
                              <MdHandshake size={20} />
                            </span>
                            <span className="menu-link-text">Chargeback</span>
                          </div>

                          {showReconciliation ? (
                            <IoMdArrowDropup />
                          ) : (
                            <IoMdArrowDropdown />
                          )}
                        </div>
                      </li>
                    )}

                  {showReconciliation && (
                    <li className="menu-item mar-l">
                      <Link
                        to="/chargeback-dashboard"
                        className={
                          sideNavData == "/chargeback-dashboard"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <MdOutlineGridView size={18} />
                        </span>
                        <span className="menu-link-text">Dashboard</span>
                      </Link>
                    </li>
                  )}

                  {(role === "super" ||
                    role === "operation" ||
                    role === "subSuper" ||
                    role === "compliance") &&
                    showReconciliation && (
                      <li className="menu-item mar-l">
                        <Link
                          to="/create-chargeback"
                          className={
                            sideNavData == "/create-chargeback"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <FaWpforms size={18} />
                          </span>
                          <span className="menu-link-text">Add Chargeback</span>
                        </Link>
                      </li>
                    )}

                  {showReconciliation && role !== "mops" && (
                    <li className="menu-item mar-l">
                      <Link
                        to="/view-chargeback"
                        className={
                          sideNavData == "/view-chargeback"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <MdOutlineGridView size={18} />
                        </span>
                        <span className="menu-link-text">View Chargeback</span>
                      </Link>
                    </li>
                  )}
                  {/* Chargeback Statistics  Not Used Anymore */}
                  {/* {(role === "super" || role === "operation" || role === 'subSuper') &&
                showReconciliation && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/chargeback-stats"
                      className={
                        sideNavData == "/chargeback-stats"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <FaWpforms size={18} />
                      </span>
                      <span className="menu-link-text">
                        Chargeback Statistics
                      </span>
                    </Link>
                  </li>
                )} */}

                  {(role === "super" ||
                    role === "operation" ||
                    role === "compliance" ||
                    role === "subSuper") &&
                    showReconciliation && (
                      <li className="menu-item mar-l">
                        <Link
                          to="/todays-chargeback-data"
                          className={
                            sideNavData == "/todays-chargeback-data"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <MdAssignmentAdd size={18} />
                          </span>
                          <span className="menu-link-text">
                            Today's Chargebacks
                          </span>
                        </Link>
                      </li>
                    )}
                </>

                <>
                  {(role === "super" ||
                    role === "compliance" ||
                    role === "subAdmin" ||
                    role === "admin") && (
                    <li
                      className="menu-item"
                      onClick={() => {
                        setShowComplaints(!showComplaints);
                      }}
                    >
                      <div className={"select-data drop-menu"}>
                        <div className="inner-drop">
                          <span className="menu-link-icon">
                            <MdBackHand size={20} />
                          </span>
                          <span className="menu-link-text">Complaints</span>
                        </div>

                        {showComplaints ? (
                          <IoMdArrowDropup />
                        ) : (
                          <IoMdArrowDropdown />
                        )}
                      </div>
                    </li>
                  )}

                  {(role === "super" ||
                    role === "compliance" ||
                    role === "subAdmin" ||
                    role === "admin") &&
                    showComplaints && (
                      <li className="menu-item mar-l">
                        <Link
                          to="/complaints-dashboard"
                          className={
                            sideNavData == "/complaints-dashboard"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <MdOutlineGridView size={18} />
                          </span>
                          <span className="menu-link-text">Dashboard</span>
                        </Link>
                      </li>
                    )}

                  {(role === "super" || role === "compliance") &&
                    showComplaints && (
                      <li className="menu-item mar-l">
                        <Link
                          to="/create-complaints"
                          className={
                            sideNavData == "/create-complaints"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <FaWpforms size={18} />
                          </span>
                          <span className="menu-link-text">Add Complaint</span>
                        </Link>
                      </li>
                    )}

                  {(role === "super" ||
                    role === "admin" ||
                    role === "subAdmin" ||
                    role === "compliance") &&
                    showComplaints && (
                      <li className="menu-item mar-l">
                        <Link
                          to="/complaints"
                          className={
                            sideNavData == "/complaints"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <MdOutlineGridView size={18} />
                          </span>
                          <span className="menu-link-text">
                            Complaints List
                          </span>
                        </Link>
                      </li>
                    )}
                </>

                {/* auto switch */}
                {(role == "super" ||
                  role == "operation" ||
                  role === "subSuper" ||
                  role === "trafficManager") && (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setShowAutoSwitch(!showAutoSwitch);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <TbCloudDataConnection size={20} />
                        </span>
                        <span className="menu-link-text">Auto Switch</span>
                      </div>

                      {showAutoSwitch ? (
                        <IoMdArrowDropup />
                      ) : (
                        <IoMdArrowDropdown />
                      )}
                    </div>
                  </li>
                )}

                {showAutoSwitch && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/register-provider"
                      className={
                        sideNavData == "/register-provider"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdAssignmentAdd size={18} />
                      </span>
                      <span className="menu-link-text">Register Provider</span>
                    </Link>
                  </li>
                )}

                {showAutoSwitch && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/view-auto-switch"
                      className={
                        sideNavData == "/view-auto-switch"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdOutlineViewKanban size={18} />
                      </span>
                      <span className="menu-link-text">View Auto Switch</span>
                    </Link>
                  </li>
                )}
                {showAutoSwitch && role !== "trafficManager" && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/vpa-pool"
                      className={
                        sideNavData == "/vpa-pool"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <TbRegistered size={18} />
                      </span>
                      <span className="menu-link-text">Register VPA Pool</span>
                    </Link>
                  </li>
                )}
                {(role === "super" ||
                  role === "operation" ||
                  role === "subSuper" ||
                  role === "fundLoad") && (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setShowWallet(!showWallet);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <BiMessageAltCheck size={20} />
                        </span>
                        <span className="menu-link-text">Wallet</span>
                      </div>

                      {showWallet ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </div>
                  </li>
                )}

                {showWallet &&
                  (role === "super" ||
                    role === "operation" ||
                    role === "subSuper" ||
                    role === "fundLoad") && (
                    <>
                      <li className="menu-item mar-l">
                        <Link
                          to="/wallet-upload"
                          className={
                            sideNavData == "/wallet-upload"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <MdAssignmentAdd size={18} />
                          </span>
                          <span className="menu-link-text">Wallet Upload</span>
                        </Link>
                      </li>

                      {/* <li className="menu-item mar-l">
                  <Link
                    to="/wallet-balance"
                    className={
                      sideNavData == "/wallet-balance"
                        ? "menu-link selected-tab select-data"
                        : "menu-link select-data"
                    }
                  >
                    <span className="menu-link-icon">
                      <MdOutlineViewKanban size={18} />
                    </span>
                    <span className="menu-link-text">Wallet Balance</span>
                  </Link>
                </li> */}

                      <li className="menu-item mar-l">
                        <Link
                          to="/wallet-transactions"
                          className={
                            sideNavData == "/wallet-transactions"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <MdOutlineViewKanban size={18} />
                          </span>
                          <span className="menu-link-text">
                            Wallet Transactions
                          </span>
                        </Link>
                      </li>

                      {/* <li className="menu-item mar-l">
                  <Link
                    to="/wallet-pending"
                    className={
                      sideNavData == "/wallet-pending"
                        ? "menu-link selected-tab select-data"
                        : "menu-link select-data"
                    }
                  >
                    <span className="menu-link-icon">
                      <MdHandshake size={18} />
                    </span>
                    <span className="menu-link-text">Wallet Pending</span>
                  </Link>
                </li> */}
                    </>
                  )}

                {(role === "accounts" ||
                  role == "super" ||
                  role == "fundLoad" ||
                  role == "operation" ||
                  role === "subSuper" ||
                  role === "subAdmin" ||
                  role == "admin") && (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setShowSettlement(!showSettlement);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <TbCloudDataConnection size={20} />
                        </span>
                        <span className="menu-link-text">Settlements</span>
                      </div>

                      {showSettlement ? (
                        <IoMdArrowDropup />
                      ) : (
                        <IoMdArrowDropdown />
                      )}
                    </div>
                  </li>
                )}
                {/* {showSettlement && (
              <li className="menu-item mar-l">
                <Link
                  to="/add-settlement"
                  className={
                    sideNavData == "/add-settlement"
                      ? "menu-link selected-tab select-data"
                      : "menu-link select-data"
                  }
                >
                  <span className="menu-link-icon">
                    <MdAssignmentAdd size={18} />
                  </span>
                  <span className="menu-link-text">Add Settlement</span>
                </Link>
              </li>
            )} */}

                {(role === "accounts" ||
                  role === "super" ||
                  role === "operation" ||
                  role === "subSuper" ||
                  role === "fundLoad") &&
                  showSettlement && (
                    <li className="menu-item mar-l">
                      <Link
                        to="/settlement-report"
                        className={
                          sideNavData == "/settlement-report"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <MdDetails size={18} />
                        </span>
                        <span className="menu-link-text">
                          Settlement Report
                        </span>
                      </Link>
                    </li>
                  )}
                {showSettlement && (
                  <>
                    {(role === "accounts" ||
                      role === "super" ||
                      role === "fundLoad" ||
                      role === "subSuper" ||
                      role === "operation") && (
                      <li className="menu-item mar-l">
                        <Link
                          to="/provider-settlement"
                          className={
                            sideNavData == "/provider-settlement"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <MdAvTimer size={19} />
                          </span>
                          <span className="menu-link-text">
                            Total Provider Settlement
                          </span>
                        </Link>
                      </li>
                    )}
                  </>
                )}

                {showSettlement && (
                  <li className="menu-item mar-l">
                    <Link
                      to="/merchant-settlement"
                      className={
                        sideNavData == "/merchant-settlement"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdScreenLockPortrait size={18} />
                      </span>
                      <span className="menu-link-text">
                        Merchant Settlement
                      </span>
                    </Link>
                  </li>
                )}

                {showSettlement && (
                  <>
                    {(role === "accounts" ||
                      role === "super" ||
                      role === "subSuper" ||
                      role === "operation" ||
                      role === "fundLoad") && (
                      <li className="menu-item mar-l">
                        <Link
                          to="/view-settlement"
                          className={
                            sideNavData == "/view-settlement"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <MdOutlineViewKanban size={18} />
                          </span>
                          <span className="menu-link-text">
                            View Settlement
                          </span>
                        </Link>
                      </li>
                    )}
                  </>
                )}
                {showSettlement && (
                  <>
                    {(role === "super" || role === "subSuper") && (
                      <li className="menu-item mar-l">
                        <Link
                          to="/approve-settlement"
                          className={
                            sideNavData == "/approve-settlement"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <MdCheckBox size={18} />
                          </span>
                          <span className="menu-link-text">
                            Approve Settlement
                          </span>
                        </Link>
                      </li>
                    )}
                    {(role === "super" || role === "subSuper") && (
                      <li className="menu-item mar-l">
                        <Link
                          to="/approve-rr-settlement"
                          className={
                            sideNavData == "/approve-rr-settlement"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <MdChecklistRtl size={18} />
                          </span>
                          <span className="menu-link-text">
                            Approve RR Settlement
                          </span>
                        </Link>
                      </li>
                    )}
                  </>
                )}

                {(role === "admin" || role === "subAdmin") && (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setShowWallet(!showWallet);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <BiMessageAltCheck size={20} />
                        </span>
                        <span className="menu-link-text">Wallet</span>
                      </div>

                      {showWallet ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </div>
                  </li>
                )}

                {showWallet && (role === "admin" || role === "subAdmin") && (
                  <>
                    {/* <li className="menu-item mar-l">
                  <Link
                    to="/wallet-request"
                    className={
                      sideNavData == "/wallet-request"
                        ? "menu-link selected-tab select-data"
                        : "menu-link select-data"
                    }
                  >
                    <span className="menu-link-icon">
                      <MdAssignmentAdd size={18} />
                    </span>
                    <span className="menu-link-text">Wallet Request</span>
                  </Link>
                </li> */}
                    <li className="menu-item mar-l">
                      <Link
                        to="/wallet-history"
                        className={
                          sideNavData == "/wallet-history"
                            ? "menu-link selected-tab select-data"
                            : "menu-link select-data"
                        }
                      >
                        <span className="menu-link-icon">
                          <MdOutlineViewKanban size={18} />
                        </span>
                        <span className="menu-link-text">Wallet History</span>
                      </Link>
                    </li>
                  </>
                )}
                {role === "pros" && (
                  <li className="menu-item">
                    <Link
                      to="/not-found-webhook"
                      className={
                        sideNavData == "/not-found-webhook"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <MdErrorOutline size={20} />
                      </span>
                      <span className="menu-link-text">404 Webhooks</span>
                    </Link>
                  </li>
                )}
                {(role === "pros" ||
                  role === "operation" ||
                  role === "super") && (
                  <li className="menu-item">
                    <Link
                      to="/vpa-refund"
                      className={
                        sideNavData == "/vpa-refund"
                          ? "menu-link selected-tab select-data"
                          : "menu-link select-data"
                      }
                    >
                      <span className="menu-link-icon">
                        <CurrencyBitcoin size={20} />
                      </span>
                      <span className="menu-link-text">Refund Amount</span>
                    </Link>
                  </li>
                )}
                {(role === "super" ||
                  role === "operation" ||
                  role === "subSuper" ||
                  role === "trafficManager") && (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setProvoderWallet(!providerWallet);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <IoWallet size={20} />
                        </span>
                        <span className="menu-link-text">Provider Wallet</span>
                      </div>

                      {providerWallet ? (
                        <IoMdArrowDropup />
                      ) : (
                        <IoMdArrowDropdown />
                      )}
                    </div>
                  </li>
                )}

                {providerWallet &&
                  (role === "super" ||
                    role === "operation" ||
                    role === "subSuper" ||
                    role === "trafficManager") && (
                    <>
                      <li className="menu-item mar-l">
                        <Link
                          to="/provider-wallet"
                          className={
                            sideNavData == "/provider-wallet"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <MdAssignmentAdd size={18} />
                          </span>
                          <span className="menu-link-text">
                            Wallet Report & Upload
                          </span>
                        </Link>
                      </li>

                      <li className="menu-item mar-l">
                        <Link
                          to="/provider-balance"
                          className={
                            sideNavData == "/provider-balance"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <CurrencyBitcoin size={18} />
                          </span>
                          <span className="menu-link-text">
                            Provider Balance
                          </span>
                        </Link>
                      </li>
                    </>
                  )}

                {(role === "super" ||
                  role === "subSuper" ||
                  role === "operation" ||
                  role === "pros" ||
                  role === "compliance") && (
                  <li
                    className="menu-item"
                    onClick={() => {
                      setSupport(!support);
                    }}
                  >
                    <div className={"select-data drop-menu"}>
                      <div className="inner-drop">
                        <span className="menu-link-icon">
                          <BiSupport size={20} />
                        </span>
                        <span className="menu-link-text">Support</span>
                      </div>

                      {support ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                    </div>
                  </li>
                )}

                {support &&
                  (role === "super" ||
                    role === "subSuper" ||
                    role === "operation" ||
                    role === "pros" ||
                    role === "compliance") && (
                    <>
                      <li className="menu-item mar-l">
                        <Link
                          to="/pre-chargeback-evaluation"
                          className={
                            sideNavData == "/pre-chargeback-evaluation"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <FaListCheck size={18} />
                          </span>
                          <span className="menu-link-text">
                            Transaction Evaluation
                          </span>
                        </Link>
                      </li>
                      <li className="menu-item mar-l">
                        <Link
                          to="/block-fraud-users"
                          className={
                            sideNavData == "/block-fraud-users"
                              ? "menu-link selected-tab select-data"
                              : "menu-link select-data"
                          }
                        >
                          <span className="menu-link-icon">
                            <TbLockAccessOff size={18} />
                          </span>
                          <span className="menu-link-text">
                            Block Fraud Users
                          </span>
                        </Link>
                      </li>
                    </>
                  )}
                <>
                  {/* ================= RESELLER DIRECT VIEW ================= */}
                  {isReseller ? (
                    <>
                      {hasResellerAccess && (
                        <MenuItem
                          to="/get-reseller-data"
                          icon={MdOutlineGridView}
                          label="Dashboard"
                        />
                      )}

                      <MenuItem
                        to="/get-reseller-management"
                        icon={FaListCheck}
                        label="View Merchants"
                      />

                      <MenuItem
                        to="/get-reseller-wallet"
                        icon={BiMessageAltCheck}
                        label="Wallet Transactions"
                      />
                    </>
                  ) : (
                    <>
                      {/* ================= RESELLER DROPDOWN ================= */}
                      {hasResellerAccess && (
                        <li
                          className="menu-item"
                          onClick={() => setReseller(!reseller)}
                        >
                          <div className="select-data drop-menu">
                            <div className="inner-drop">
                              <span className="menu-link-icon">
                                <FaSellcast size={20} />
                              </span>
                              <span className="menu-link-text">Reseller</span>
                            </div>
                            {reseller ? (
                              <IoMdArrowDropup />
                            ) : (
                              <IoMdArrowDropdown />
                            )}
                          </div>
                        </li>
                      )}

                      {reseller && (
                        <>
                          <MenuItem
                            to="/get-reseller-data"
                            icon={MdOutlineGridView}
                            label="Dashboard"
                          />

                          {isReseller ? (
                            <MenuItem
                              to="/get-reseller-management"
                              icon={FaListCheck}
                              label="View Merchants"
                            />
                          ) : (
                            <MenuItem
                              to="/get-reseller"
                              icon={FaListCheck}
                              label="View Reseller"
                            />
                          )}

                          {canAddResellerWallet && (
                            <MenuItem
                              to="/reseller-wallet"
                              icon={MdAssignmentAdd}
                              label="Reseller Fund Load"
                            />
                          )}

                          <MenuItem
                            to="/get-reseller-wallet"
                            icon={BiMessageAltCheck}
                            label="Wallet Transactions"
                          />
                        </>
                      )}
                    </>
                  )}
                </>
                {role !== "reseller" && (
                  <button className="helpdesk-btn" onClick={openSupportPortal}>
                    <span className="menu-link-icon-helpdesk">
                      <BiSupport size={18} />
                    </span>

                    <span>Helpdesk</span>
                  </button>
                )}
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
